
import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { PEClaimsCardActions, PEClaimsCardGetters, PEClaimsCardMutations } from './pe-claim-card'
import { PECrimesCardActions, PECrimesCardGetters, PECrimesCardMutations } from './pe-crime-card'
import { PEDeclarationCardActions, PEDeclarationCardGetters, PEDeclarationCardMutations } from './pe-declaration-card'
import {
  PEEligibilityGuideCardActions, PEEligibilityGuideCardGetters, PEEligibilityGuideCardMutations,
} from './pe-eligibility-guide-card'
import {
  PEFirmResettlementsCardActions, PEFirmResettlementsCardGetters, PEFirmResettlementsCardMutations,
} from './pe-firm-resettlement-card'
import {
  PENationalSecuritiesCardActions, PENationalSecuritiesCardGetters, PENationalSecuritiesCardMutations,
} from './pe-national-security-card'
import {
  PEOneYearFilingDeadlinesCardActions, PEOneYearFilingDeadlinesCardGetters, PEOneYearFilingDeadlinesCardMutations,
} from './pe-one-year-filling-deadline-card'
import {
  PEPersecutorAnalysisCardActions, PEPersecutorAnalysisCardGetters, PEPersecutorAnalysisCardMutations,
} from './pe-persecutor-analisis-card'
import {
  PEPreviousDenialsCardActions, PEPreviousDenialsCardGetters, PEPreviousDenialsCardMutations,
} from './pe-previous-denial-card'
import {
  PESafeThirdCountriesCardActions, PESafeThirdCountriesCardGetters, PESafeThirdCountriesCardMutations,
} from './pe-safe-third-countries-card'

export const AsylumAssystantSectionActions = {
  peInitAsylumAssistantSection: async ({ commit, getters }) => {
    commit('peSetAsylumAssistant', { ...AsylumAssistantSectionState })

    // Fetch all asylum assistant types in a single API call
    const party = getters.peParty
    const types = [
      'claim',
      'crime',
      'declaration',
      'eligibility_guide',
      'firm_resettlement',
      'national_security',
      'one_year_filing_deadline',
      'persecutor_analysis',
      'previous_denial',
      'safe_third_country',
    ]

    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { types } }).
      then(({ data }) => {
        const assistantData = data?.asylum_assistant || {}

        // Update all sections at once
        commit('pePatchAsylumAssistantList', { assistant: 'claims', list: assistantData.claims || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'crimes', list: assistantData.crimes || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'declarations', list: assistantData.declarations || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'eligibilityGuides', list: assistantData.eligibility_guides || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'firmResettlements', list: assistantData.firm_resettlements || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'nationalSecurities', list: assistantData.national_securities || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'oneYearFilingDeadlines', list: assistantData.one_year_filing_deadlines || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'persecutorAnalysis', list: assistantData.persecutor_analyses || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'previousDenials', list: assistantData.previous_denials || [] })
        commit('pePatchAsylumAssistantList', { assistant: 'safeThirdCountries', list: assistantData.safe_third_countries || [] })
      }).
      catch(handleError)
  },
  ...PEClaimsCardActions,
  ...PECrimesCardActions,
  ...PEDeclarationCardActions,
  ...PEEligibilityGuideCardActions,
  ...PEFirmResettlementsCardActions,
  ...PENationalSecuritiesCardActions,
  ...PEOneYearFilingDeadlinesCardActions,
  ...PEPersecutorAnalysisCardActions,
  ...PEPreviousDenialsCardActions,
  ...PESafeThirdCountriesCardActions,
}

export const AsylumAssystantSectionGetters = {
  peEligibilityAssistant: state => state.partyEdit.asylumAssystant || {},
  ...PEClaimsCardGetters,
  ...PECrimesCardGetters,
  ...PEDeclarationCardGetters,
  ...PEEligibilityGuideCardGetters,
  ...PEFirmResettlementsCardGetters,
  ...PENationalSecuritiesCardGetters,
  ...PEOneYearFilingDeadlinesCardGetters,
  ...PEPersecutorAnalysisCardGetters,
  ...PEPreviousDenialsCardGetters,
  ...PESafeThirdCountriesCardGetters,
}

export const AsylumAssystantSectionMutations = {
  peSetAsylumAssistant: (state, asylumAssistant) => { state.partyEdit.asylumAssystant = asylumAssistant },
  pePatchAsylumAssistantList: (state, { assistant, list }) => {
    Vue.set(state.partyEdit.asylumAssystant, assistant, list)
  },
  pePatchAsylumAssistant: (state, { assistant, value }) => {
    const index = state.partyEdit.asylumAssystant[assistant]?.findIndex(i => i.id === value.id)
    Vue.set(state.partyEdit.asylumAssystant[assistant], index, value)
  },
  ...PEClaimsCardMutations,
  ...PECrimesCardMutations,
  ...PEDeclarationCardMutations,
  ...PEEligibilityGuideCardMutations,
  ...PEFirmResettlementsCardMutations,
  ...PENationalSecuritiesCardMutations,
  ...PEOneYearFilingDeadlinesCardMutations,
  ...PEPersecutorAnalysisCardMutations,
  ...PEPreviousDenialsCardMutations,
  ...PESafeThirdCountriesCardMutations,
}

const AsylumAssistantSectionState = {
  claims: [],
  crimes: [],
  declarations: [],
  eligibilityGuides: [],
  firmResettlements: [],
  nationalSecurities: [],
  oneYearFilingDeadlines: [],
  persecutorAnalysis: [],
  previousDenials: [],
  safeThirdCountries: [],
}
